import React from 'react'

const style = require('./index.css')

interface Props {
  src: string;
  name:string;
  additionalClasses?: string
}

export const AttractionImage = ({ src, name, additionalClasses }: Props) =>
  src && (<img src={src} alt={name} className={`${style.attractionImage} ${additionalClasses}`} />)
